module.exports = __webpack_public_path__ + "static/media/peanut1.dcbc3159.png";